"use strict";
var Observable_1 = require('../../Observable');
var cache_1 = require('../../operator/cache');
Observable_1.Observable.prototype.cache = cache_1.cache;
//# sourceMappingURL=cache.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/cache.js
 ** module id = 383
 ** module chunks = 9
 **/